const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const SummaryQuery: any = {
    GetSummaryById: Backofficebff + '/v1/paymentconsolidation/get-payment-consolidation-by-id',
};
